import type { EvalTypeMetadata } from '@/types/eval-v2-types';
import { apiRequest } from '@/utils/api-request';

/** Fetches the static catalog of supported v2 eval types (id, name,
 *  description) from platform-api. Used by the Eval Builder to render
 *  inline per-type descriptions. The catalog is global (not org-scoped). */
export const getEvalTypes = async (): Promise<EvalTypeMetadata[]> => {
  const response = await apiRequest<EvalTypeMetadata[]>({
    url: '/v2/evaluations/types',
    method: 'GET',
    target: 'platform',
  });
  if (response.success === false || response.detail) {
    throw new Error(response.detail || 'Failed to load eval type catalog');
  }
  const items = (response.data as EvalTypeMetadata[]) || [];
  return items.map((item) => ({
    ...item,
    description: item.description ?? '',
    sections: item.sections ?? [],
  }));
};
